import React from 'react'
import { useQuery, useMutation, useQueryClient, queryCache } from '@tanstack/react-query'
import { useSnackbar } from 'notistack';
import api from "~/Services/Api";
import { changeUserToInit, changeUser, reset } from "~/store/app/User";
import { useSelector, useDispatch } from "react-redux";
import { initialProduct } from '../store/app/Product';
import { initialCurrency } from '../store/app/StaticData';

export const useGetRequest = ({
    url,
    queryKey,
    dataForApi,
    headers,
    enabled = true,
    retry = 0,
    type = "*",
    fileName,
    needStorWithId = true,
    storedWithParams = false,
    withId = false
}) => {
    const queryClient = useQueryClient()
    // console.log('dataForApi', queryKey, dataForApi)
    const user = useSelector((state) => state?.app?.user)
    const app = useSelector((state) => state?.app?.app)
    const dispatch = useDispatch()

    const { enqueueSnackbar } = useSnackbar();
    const handleClickVariant = (data, variant) => {
        // variant could be success, error, warning, info, or default
        enqueueSnackbar(data, { variant });
    };


    let { data, error, refetch, isLoading, isPending, isRefetching, isError } = useQuery({
        queryKey: !!storedWithParams ? [queryKey, JSON.stringify(dataForApi)] : !dataForApi?.id ? [queryKey] : needStorWithId ? [queryKey, dataForApi?.id] : [queryKey],
        // queryKey: !dataForApi?.id ? [queryKey] : [queryKey, dataForApi?.id],
        // queryKey: [queryKey],

        // queryKey: !dataForApi?.id ? [queryKey] : needStorWithId ? [queryKey, dataForApi?.id] : [queryKey],
        // queryKey: !dataForApi?.id ? [queryKey] : needStorWithId ? [queryKey, dataForApi?.id] : [queryKey],
        // queryKey: [queryKey, dataForApi?.id],
        // queryKey: [queryKey, dataForApi?.params.length, dataForApi?.params.start],
        // z.replace("{","").replace(/.$/,"")
        queryFn: async () => {
            // if (withId && (!dataForApi?.params?.id && !dataForApi?.id)) {
            if (withId && (!dataForApi?.id)) {
                // console.log("❌ Skipping API Call - Missing ID");
                return null; // أو throw Error أو بيانات افتراضية
            }
            // console.log("🔍 Running Query For:", queryKey, enabled, dataForApi);
            if (!url || typeof url !== 'string') {
                console.error("❌ Invalid URL:", url);
                return null;
            }
            let Api = url.split('.')
            if (!Api || Api.length < 2 || !api[Api[0]] || !api[Api[0]][Api[1]]) {
                console.error("❌ Invalid API path:", url, "Api:", Api, "Available:", Object.keys(api));
                return null;
            }
            return await api[Api[0]][Api[1]](dataForApi, headers = {
                Authorization: user?.token,
                lang: app.locale,
                ...headers
            })
                .then(response => {
                    return response?.data
                })
        },
        // enabled: !!dataForApi?.id,
        enabled: enabled,
        retry: retry,
        keepPreviousData: true,
        refetchOnWindowFocus: false,
        networkMode: "offlineFirst",
        // staleTime: 1000 * 60 * 5, // **جعل البيانات حديثة لمدة 5 دقائق (يمنع إعادة الجلب)**
        // cacheTime: 1000 * 60 * 10, // **الاحتفاظ بالبيانات في الكاش لمدة 10 دقائق**
        // refetchOnMount: false, // **عدم إعادة جلب البيانات عند تحميل الصفحة**
        // refetchOnReconnect: true, // **عدم إعادة الجلب عند استعادة الاتصال بالإنترنت**
        // refetchInterval: 5000,
        // notifyOnChangeProps: ['data'],
        // refetchIntervalInBackground: false,

        // staleTime: 1000 * 60 * 5, // 5 minutes
        // initialData: () => {
        //     // Optionally provide initial data from cache
        //     return queryClient.getQueryData(!dataForApi?.id ? [queryKey] : needStorWithId ? [queryKey, dataForApi?.id] : [queryKey]);
        // },
    })
    if (!!error?.response?.data?.code) {
        if (error?.response?.data?.code === "E004") {
            queryClient.clear();
            dispatch(
                changeUserToInit()
            )
            localStorage.clear();
            dispatch(
                changeUser({
                    data: {},
                    roles: [],
                    token: ""
                })
            )
            dispatch(
                initialProduct()
            )
            dispatch(
                initialCurrency()
            )
        }
    }

    return { data, error, refetch, isLoading, isPending, isRefetching, isError }
}

export const useGetByIdRequest = ({
    url,
    queryKey,
    dataForApi,
    headers,
    enabled = true,
    retry = 0
}) => {
    const queryClient = useQueryClient()

    const user = useSelector((state) => state?.app?.user)
    const dispatch = useDispatch()

    const { enqueueSnackbar } = useSnackbar();
    const handleClickVariant = (data, variant) => {
        // variant could be success, error, warning, info, or default
        enqueueSnackbar(data, { variant });
    };

    let { data, error, refetch, isLoading, isPending, isRefetching, isError } = useQuery({
        queryKey: [queryKey, dataForApi?.id],
        queryFn: async () => {
            let Api = url.split('.')
            return await api[Api[0]][Api[1]](dataForApi, headers = {
                Authorization: user?.token,
                ...headers
            })
                .then(response => {
                    return response?.data
                })
        },
        // enabled: !!dataForApi?.id,
        enabled: !!dataForApi?.id,
        retry: retry,
        keepPreviousData: true,
        refetchOnWindowFocus: false
    })
    if (!!error?.response?.data?.code) {
        if (error?.response?.data?.code === "E004") {
            // console.log('first')
            queryClient.clear();
            dispatch(
                changeUserToInit()
            )
        }
    }

    return { data, error, refetch, isLoading, isPending, isRefetching, isError }
}

export const usePostRequest = ({
    url,
    headers,
    queryKey,
    isEdit = false,
    cashWithId = false,
    DoYouWantToAddAllTheDataEnteredToTheCache = false,
    Do_you_want_to_replace_only_variable_values = false,
    DoYouWantToReplaceTheDataInTheCacheWithNewData = false,
    onSuccess,
}) => {
    const user = useSelector((state) => state?.app?.user)
    const { enqueueSnackbar } = useSnackbar();
    const handleClickVariant = (data, variant) => {
        // variant could be success, error, warning, info, or default
        enqueueSnackbar(data, { variant });
    };

    const queryClient = useQueryClient()

    return useMutation({
        mutationFn: (data) => {
            let Api = url?.split('.')
            return api[Api[0]][Api[1]](data, headers = {
                Authorization: user?.token,
                ...headers
            })
        },
        onMutate: async (newData) => {
            await queryClient.cancelQueries({ queryKey: !!cashWithId ? [queryKey, newData.idForCash] : [queryKey] })
            const previousHeroData = queryClient.getQueryData(!!cashWithId ? [queryKey, newData.idForCash] : [queryKey])
            if (!!queryKey) {
                if (!!DoYouWantToAddAllTheDataEnteredToTheCache) {
                    if (!!isEdit) {
                        if (!!cashWithId) {
                            let updatedValue = [...previousHeroData?.data];
                            const result = updatedValue.map((item) => !!newData.body.id ? item.id === newData.body.id ? newData.body : item : item.id === newData.id ? newData.body : item);
                            queryClient.setQueryData([queryKey, newData.id], (oldQueryData) => {
                                return {
                                    ...oldQueryData,
                                    data: result
                                }
                            });
                            return () => queryClient.setQueryData([queryKey, newData.id], previousHeroData);
                        }
                        let updatedValue = [...previousHeroData?.data];
                        const result = updatedValue.map((item) => !!newData.body.id ? item.id === newData.body.id ? newData.body : item : item.id === newData.id ? newData.body : item);
                        queryClient.setQueryData([queryKey], (oldQueryData) => {
                            return {
                                ...oldQueryData,
                                data: result
                            }
                        });
                        return () => queryClient.setQueryData([queryKey], previousHeroData);
                    } else {
                        const updatedValue = [...previousHeroData.payload];
                        const margeData = [newData?.body, ...updatedValue]
                        queryClient.setQueryData([queryKey], (oldQueryData) => {
                            return {
                                ...oldQueryData,
                                payload: margeData
                            }
                        });
                        return () => queryClient.setQueryData([queryKey], previousHeroData);
                    }
                }
            }
            return { previousHeroData, newData }
        },
        onSettled: (data, error, variables, context) => {
            !!queryKey &&
                !!data?.statusText && !!DoYouWantToReplaceTheDataInTheCacheWithNewData && queryClient.setQueryData([queryKey], (oldQueryData) => {
                    if (!!oldQueryData) {
                        const newKeyResponseData = Object.entries(data?.data?.payload).reduce((acc, [key, value]) => ({
                            ...acc,
                            ...(key === "admin" ? { ["InsuranceCompanies"]: value } : { [key]: value }),
                        }), {});

                        const MergeObjectsAndReplaceTheValueOfSimilarKeys = (...objects) => {
                            const MergeObjects = objects.map(object => JSON.parse(JSON.stringify(object)));
                            if (Array.isArray(MergeObjects[1])) {
                                const arrayCopy = [...MergeObjects[1]];
                                arrayCopy.push(MergeObjects[0]);
                                return arrayCopy;
                            }
                            return MergeObjects.reduce((merged, current) => ({ ...current, ...merged }), {});
                        }

                        const newCashData = MergeObjectsAndReplaceTheValueOfSimilarKeys(data?.data?.payload, oldQueryData?.payload);
                        queryClient.invalidateQueries({ queryKey: [queryKey] })
                        return {
                            ...oldQueryData,
                            payload: newCashData
                        }
                    } else {
                        queryClient.invalidateQueries({ queryKey: [queryKey] })
                        return {
                            ...data?.data?.payload
                        }
                    }
                })
            if (!!queryKey) {
                if (!!data?.statusText) {
                    if (!!Do_you_want_to_replace_only_variable_values) {
                        const previousHeroData = queryClient.getQueryData([queryKey])
                        let updatedValue = [...previousHeroData.payload];
                        const result = updatedValue.map((item) => item.id === variables.params.id ? data.data.payload : item);
                        queryClient.setQueryData([queryKey], (oldQueryData) => {
                            if (!!oldQueryData) {
                                return {
                                    ...oldQueryData,
                                    payload: result
                                }
                            } else {
                                return {
                                    ...data?.payload
                                }
                            }
                        });
                        queryClient.invalidateQueries({ queryKey: [queryKey] })
                        return () => queryClient.setQueryData([queryKey], previousHeroData);
                    }
                }
            }

            !data && !!error?.response && handleClickVariant(`${error?.response?.data?.message}`, 'warning')
            !data && !error?.response && handleClickVariant(`${error?.message}`, 'error')
            data?.status === 200 && !!data?.data?.message && handleClickVariant(data?.data?.message, 'info')
            data?.status === 200 && !data?.data?.message && handleClickVariant("operation accomplished successfully", 'info')
            if (!!queryKey) {
                return queryClient.invalidateQueries({ queryKey: !!cashWithId ? [queryKey, variables.idForCash] : [queryKey] })
            }
        },
        onSuccess: (data, variables, context) => {
            if (onSuccess) {
                onSuccess(data, variables, context);
            }
        },
    })
}

export const usePostRequestCahsh = (
    {
        url,
        headers,
        queryKey,
        cashWithId = false,
        elementOfPayload
    }
) => {
    const user = useSelector((state) => state?.app?.user)
    const { enqueueSnackbar } = useSnackbar();
    const handleClickVariant = (data, variant) => {
        // variant could be success, error, warning, info, or default
        enqueueSnackbar(data, { variant });
    };

    const queryClient = useQueryClient()

    return useMutation({
        mutationFn: (data) => {
            let Api = url?.split('.')
            return api[Api[0]][Api[1]](data, headers = {
                Authorization: user?.token,
                ...headers
            })
        },
        onMutate: async (newData) => {
            // console.log('newData', newData)
            await queryClient.cancelQueries({ queryKey: !!cashWithId ? [queryKey, newData.idForCash] : [queryKey] })
            const previousHeroData = queryClient.getQueryData(!!cashWithId ? [queryKey, newData.idForCash] : [queryKey])
            queryClient.setQueryData([queryKey], (oldItems) => {
                if (!!elementOfPayload) {
                    return {
                        // ...(console.log('oldItems', elementOfPayload, oldItems?.payload[elementOfPayload])),
                        ...(oldItems || {}),
                        payload: {
                            ...oldItems.payload,
                            [elementOfPayload]: [{ ...newData?.body, idForCashed: newData?.idForCashed }, ...oldItems?.payload[elementOfPayload]]
                        }
                    }
                } else {
                    return {
                        ...(oldItems || {}),
                        // payload: [...oldItems?.payload, { ...newData?.body, idForCashed: newData?.idForCashed }]
                        payload: [{ ...newData?.body, idForCashed: newData?.idForCashed }, ...oldItems?.payload]
                    }
                }
            }
            );

            return { previousHeroData };
        },
        retry: 1,
        // networkMode: 'offlineFirst',
        // cacheTime: 1000
        onError: (error, newItem, context) => {
            // console.log('error,', error, context)
            handleClickVariant(`${error?.response?.data?.message}`, 'warning')
            queryClient.setQueryData([queryKey], context.previousHeroData);
        },
        onSuccess: (data, newItem) => {
            // console.log('data, newItem', data, newItem)
            queryClient.setQueryData([queryKey], (oldItems) => {
                if (!!elementOfPayload) {
                    return {
                        ...(oldItems || {}),
                        payload: {
                            ...oldItems.payload,
                            [elementOfPayload]: oldItems?.payload[elementOfPayload]?.map(item => (
                                item.idForCashed === newItem.idForCashed ? { ...item, ...data?.data?.payload } : item
                            ))
                        }
                    }
                } else {
                    return {
                        ...(oldItems || {}),
                        payload: oldItems?.payload?.map(item => (
                            item.idForCashed === newItem.idForCashed ? { ...item, ...data?.data?.payload[0] } : item
                        ))
                    }
                }
            });
        },
    })
}

export const useDeleteRequest = ({
    url,
    queryKey,
    headers,
    DoYouWantToAddAllTheDataEnteredToTheCache = true,
    DoYouWantToReplaceTheDataInTheCacheWithNewData = false
}) => {
    const user = useSelector((state) => state?.app?.user)
    const { enqueueSnackbar } = useSnackbar();
    const handleClickVariant = (data, variant) => {
        // variant could be success, error, warning, info, or default
        enqueueSnackbar(data, { variant });
    };

    const queryClient = useQueryClient()

    return useMutation({
        mutationFn: (data) => {
            // console.log('data', data)
            let Api = url.split('.')
            return api[Api[0]][Api[1]](data, headers = {
                Authorization: user?.token,
                ...headers
            })
        },
        onMutate: async (newData) => {
            await queryClient.cancelQueries([queryKey])
            const previousHeroData = queryClient.getQueryData([queryKey])
            if (!!queryKey) {
                if (!!DoYouWantToAddAllTheDataEnteredToTheCache) {
                    const updatedValue = [...previousHeroData.data];
                    const removeDeleted = updatedValue.filter(
                        eachValue => eachValue.id !== newData.id
                    );
                    queryClient.setQueryData([queryKey], (oldQueryData) => {
                        return {
                            ...oldQueryData,
                            data: removeDeleted
                        }
                    });
                    // console.log("::", updatedValue, removeDeleted, newData.id)
                    return () => queryClient.setQueryData([queryKey], previousHeroData);
                }
            }
            queryClient.invalidateQueries({ queryKey: [queryKey] })
            return { previousHeroData };
        },
        onSettled: (data, error, newData) => {
            // queryClient.removeQueries([queryKey, newData.id]);
            // queryClient.refetchQueries(queryKey);

            !data && !!error?.response && handleClickVariant(`${error?.response?.data?.message}`, 'warning')
            !data && !error?.response && handleClickVariant(`${error?.message}`, 'error')
            !!data?.statusText && !!data?.data?.message && handleClickVariant(data?.data?.message, 'info')
            !!data?.statusText && !data?.data?.message && handleClickVariant("operation accomplished successfully", 'info')
            // console.log('data', data, error, data?.response?.data?.message)
            // queryClient.refetchQueries({ queryKey: [queryKey] });
            queryClient.invalidateQueries({ queryKey: [queryKey] })
        }
    })
}

// export const useDeleteFn = () => {
//     return useMutation(
//         (data) => console.log('data', data),
//         {
//             onMutate: editedValue => {
//                 const previousValue = queryCache.getQueryData("super-herose");
//                 const updatedValue = [...previousValue];
//                 const removeDeleted = updatedValue.filter(
//                     eachValue => eachValue.id !== editedValue.id
//                 );

//                 queryCache.setQueryData("super-herose", removeDeleted);

//                 return () => queryCache.setQueryData("super-herose", previousValue);
//             },

//             onError: (error, editedValue, rollback) => {
//                 rollback();
//             },

//             onSettled: (data, error, editedValue) => {
//                 queryCache.removeQueries(["super-herose", editedValue.id]);
//                 queryCache.refetchQueries("super-herose");
//             }
//         }
//     );
// };

// export const useDeleteSuperHeroData = () => {
//     // const { enqueueSnackbar } = useSnackbar();
//     // const handleClickVariant = (data, variant) => {
//     //     // variant could be success, error, warning, info, or default
//     //     enqueueSnackbar(data, { variant });
//     // };
//     const queryClient = useQueryClient()
//     return useMutation((data) => axios.delete(`http://localhost:4000/superherose/${1}`), {
//         onMutate: async (newHero) => {
//             console.log('newHero', newHero)
//             const previousValue = queryClient.getQueryData("super-herose");
//             const updatedValue = [...previousValue.data];
//             const removeDeleted = updatedValue.filter(
//                 eachValue => eachValue.id !== newHero.id
//             );

//             queryClient.setQueryData("super-herose", removeDeleted);

//             return () => queryClient.setQueryData("super-herose", previousValue);
//         },
//         onError: (error, editedValue, rollback) => {
//             rollback();
//             // handleClickVariant(error.message, 'error')
//         },

//         onSettled: (data, error, editedValue) => {
//             // !error && handleClickVariant("ok...", 'success')
//             queryClient.removeQueries(["super-herose", editedValue.id]);
//             queryClient.refetchQueries("super-herose");
//         }
//     })
// }